import { tasks, DONE } from './tasks';

export default function frame ({frame, duration = 1000, startTime = 0, repeat = 0, delay = 0, repeatDelay = 0, yoyo = false, reversed = false, easing}) {

	startTime += delay + performance.now();

	tasks.push(time => {	

		if (time < startTime) {

			return false;

		}

		let elapsed = Math.min((time - startTime) / duration, 1);
		let value = easing ? easing(elapsed) : elapsed;

		if (reversed) {
			value = 1 - value;
			elapsed = 1 - elapsed;
		}

		frame(value, elapsed);

		if (elapsed === 1 || (reversed && elapsed === 0)) {

			if (repeat) {

				if (isFinite(repeat)) {
					repeat--;
				}

				if (yoyo) {

					reversed = !reversed;

				}

				startTime = time + repeatDelay;

			return true;

			} else {

			return DONE;

			}

		}

		return true;

	});
};
